document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);

  const paramMapping = {
    'form': null,
    'fname': 'firstname',
    'lname': 'lastname',
    'email': 'email',
    'company': 'company'
  };

  const formTexts = {
    'ai-toolkit': {
      heading: 'Make your AI <strong class="headline-decoration">edit documents</strong>',
      text: 'With over 20,000 businesses using Tiptap, you\'re in good company.',
      selectToolkitInput: true
    },
    'collaboration': {
      heading: 'Ready to use <strong class="headline-decoration">Collaboration in Tiptap? </strong>',
      text: 'With over 20,000 businesses using Tiptap, you\'re in good company.',
      selectToolkitInput: false
    },
    'enterprise': {
      heading: 'Ready to go <strong class="headline-decoration">Enterprise with Tiptap? </strong>',
      text: 'With over 20,000 businesses using Tiptap, you\'re in good company.',
      selectToolkitInput: false
    },
    'editor': {
      heading: 'Build your <strong class="headline-decoration">custom editor with Tiptap? </strong>',
      text: 'With over 20,000 businesses using Tiptap, you\'re in good company.',
      selectToolkitInput: false
    },
    'use-case-legal': {
      heading: 'Let\'s build your <strong class="headline-decoration">legal editing experience</strong>',
      text: 'From import to redline to export… we\'ll help you get there!',
      selectToolkitInput: false
    },
    'tracked-changes': {
      heading: 'Bring suggestion mode <strong class="headline-decoration">to your editor</strong>',
      text: 'Word-style change tracking integrated in your app.',
      selectToolkitInput: false
    }
  };

  const toolkitCheckboxContainer = document.querySelector('#interest-ai-toolkit')?.closest('.field-wrap');
  const formParam = urlParams.get('form');

  if (!formParam && toolkitCheckboxContainer) {
    toolkitCheckboxContainer.style.display = 'none';
  }

  for (const [urlParam, fieldName] of Object.entries(paramMapping)) {
    const paramValue = urlParams.get(urlParam);

    if (paramValue) {
      if (urlParam === 'form') {
        const checkbox = document.getElementById(`interest-${paramValue}`);
        if (checkbox) {
          checkbox.checked = true;
        }

        if (formTexts[paramValue]) {
          document.querySelectorAll('[data-change-headline]').forEach(heading => {
            heading.innerHTML = formTexts[paramValue].heading;
          });

          document.querySelectorAll('[data-change-text]').forEach(text => {
            text.innerHTML = formTexts[paramValue].text;
          });

          if (toolkitCheckboxContainer && Object.prototype.hasOwnProperty.call(formTexts[paramValue], 'selectToolkitInput')) {
            toolkitCheckboxContainer.style.display = formTexts[paramValue].selectToolkitInput === true ? '' : 'none';
          }
        }
      } else if (fieldName) {
        let field = document.querySelector(`[name="${fieldName}"]`);

        if (!field) {
          field = document.getElementById(fieldName);
        }

        if (field) {
          field.value = decodeURIComponent(paramValue);
        }
      }
    }
  }
});
